var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _awaitAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var _asyncIterator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var BufferList = require('bl/BufferList');

module.exports = function (source) {
  var reader = _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var bytes, bl, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, chunk, data;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return;

          case 2:
            bytes = _context.sent;
            // Allows us to receive 8 when reader.next(8) is called
            bl = new BufferList();
            _iteratorNormalCompletion = true;
            _didIteratorError = false;
            _context.prev = 6;
            _iterator = _asyncIterator(source);

          case 8:
            _context.next = 10;
            return _awaitAsyncGenerator(_iterator.next());

          case 10:
            _step = _context.sent;
            _iteratorNormalCompletion = _step.done;
            _context.next = 14;
            return _awaitAsyncGenerator(_step.value);

          case 14:
            _value = _context.sent;

            if (_iteratorNormalCompletion) {
              _context.next = 42;
              break;
            }

            chunk = _value;

            if (bytes) {
              _context.next = 23;
              break;
            }

            _context.next = 20;
            return bl.append(chunk);

          case 20:
            bytes = _context.sent;
            bl = new BufferList();
            return _context.abrupt("continue", 39);

          case 23:
            bl.append(chunk);

          case 24:
            if (!(bl.length >= bytes)) {
              _context.next = 39;
              break;
            }

            data = bl.shallowSlice(0, bytes);
            bl.consume(bytes);
            _context.next = 29;
            return data;

          case 29:
            bytes = _context.sent;

            if (bytes) {
              _context.next = 37;
              break;
            }

            if (!bl.length) {
              _context.next = 36;
              break;
            }

            _context.next = 34;
            return bl;

          case 34:
            bytes = _context.sent;
            bl = new BufferList();

          case 36:
            return _context.abrupt("break", 39);

          case 37:
            _context.next = 24;
            break;

          case 39:
            _iteratorNormalCompletion = true;
            _context.next = 8;
            break;

          case 42:
            _context.next = 48;
            break;

          case 44:
            _context.prev = 44;
            _context.t0 = _context["catch"](6);
            _didIteratorError = true;
            _iteratorError = _context.t0;

          case 48:
            _context.prev = 48;
            _context.prev = 49;

            if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
              _context.next = 53;
              break;
            }

            _context.next = 53;
            return _awaitAsyncGenerator(_iterator.return());

          case 53:
            _context.prev = 53;

            if (!_didIteratorError) {
              _context.next = 56;
              break;
            }

            throw _iteratorError;

          case 56:
            return _context.finish(53);

          case 57:
            return _context.finish(48);

          case 58:
            if (!bytes) {
              _context.next = 60;
              break;
            }

            throw Object.assign(new Error("stream ended before ".concat(bytes, " bytes became available")), {
              code: 'ERR_UNDER_READ',
              buffer: bl
            });

          case 60:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[6, 44, 48, 58], [49,, 53, 57]]);
  }))();

  reader.next();
  return reader;
};